module.exports = __webpack_public_path__ + "img/about1.95ec0b05.png";